/**
 * Every product goes through the coach's post payment form, so a product's only choice is
 * whether to follow the coach's default or pin a specific form — one field,
 * `postPaymentFormId`. These helpers keep the single dropdown in AddProductModal and
 * ProductView mapping to it.
 */
export const PPFSelection = {
  COACH_DEFAULT: '',
};

/**
 * The dropdown value matching a product's current configuration.
 *
 * @param {object} product - The product document.
 * @returns {string} - The matching dropdown value.
 */
export const getPPFSelection = (product) => product.postPaymentFormId || PPFSelection.COACH_DEFAULT;

/**
 * The product fields to write for a dropdown value. An empty `postPaymentFormId` clears
 * the pin so the product follows the coach's default.
 *
 * @param {string} selection - The selected dropdown value.
 * @returns {{ postPaymentFormId: string }} - The fields to write.
 */
export const getPPFFieldsForSelection = (selection) => ({
  postPaymentFormId: selection === PPFSelection.COACH_DEFAULT ? '' : selection,
});

/**
 * Sorts a coach's post payment forms with the default form first, then alphabetically by
 * name — shared by every PPF picker (AddProductModal, ProductView, FormSettings) so their
 * ordering never drifts apart.
 *
 * @param {string} defaultFormId - The coach's default post payment form id.
 * @returns {(a: object, b: object) => number} - Comparator for Array.prototype.sort.
 */
export const getPostPaymentFormComparator = (defaultFormId) => (a, b) => {
  const aIsDefault = a.id === defaultFormId;
  const bIsDefault = b.id === defaultFormId;
  if (aIsDefault !== bIsDefault) {
    return aIsDefault ? -1 : 1;
  }
  return (a.formName || '').localeCompare(b.formName || '');
};
